module.exports = __webpack_public_path__ + "img/balls-landscape-x2.2c3c374a.jpg";